import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type Experiments from '@alltrails/types/Experiments';

export const experimentsSlice = createSlice({
  name: 'experiments',
  initialState: {} as Experiments,
  reducers: {
    updateExperiments: (_, action: PayloadAction<Experiments>) => {
      return action.payload;
    }
  }
});

export const { updateExperiments } = experimentsSlice.actions;

export default experimentsSlice.reducer;
